<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your institutes, staff, students, finance and reports efficiently.</p>
    </div>

    <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Manage Institute
    </button>
</div>

<!-- Statistics -->
<div class="row g-3 mt-1">
    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-warning-subtle text-warning">
                <i class="bi bi-file-earmark-text"></i>
            </div>

            <div>
                <h3>6</h3>
                <p>School(s)</p>
            </div>

        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-primary-subtle text-primary">
                <i class="bi bi-people"></i>
            </div>

            <div>
                <h3>5,245</h3>
                <p>Total Students</p>
            </div>

        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-success-subtle text-success">
                <i class="bi bi-journal-check"></i>
            </div>

            <div>
                <h3>472</h3>
                <p>Staff / Teachers</p>
            </div>

        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-danger-subtle text-danger">
                <i class="bi bi-calendar-check"></i>
            </div>

            <div>
                <h3>13:1</h3>
                <p>Stdnt. : Staff Ratio</p>
            </div>

        </div>
    </div>
</div>

<div class="row g-3 mt-1">
    <div class="col-lg-7">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <div>
                    <h5>School Revenue Analytics</h5>
                    <small class="text-muted">
                        Monthly collection overview
                    </small>
                </div>
                <select class="form-select form-select-sm chart-filter">
                    <option>2026</option>
                    <option>2025</option>
                </select>
            </div>

            <apx-chart
            [series]="series1"
            [chart]="chart1"
            [xaxis]="xaxis1"
            [dataLabels]="dataLabels1"
            ></apx-chart>
        </div>
    </div>

    <div class="col-lg-5">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <div>
                    <h5>Needs Attention</h5>
                    <small class="text-muted">Top outstanding balances</small>
                </div>
                <select class="form-select form-select-sm chart-filter">
                    <option>Institute</option>
                    <option>Name of Institute</option>
                </select>
            </div>

            <div class="activity-item d-flex flex-column mb-2 pt-3 pb-0" style="line-height: 0px;">
                <small class="text-muted">Top Outstanding</small>
                <h5>9,58,962/-</h5>
            </div>

            <div class="activity-list">
                <div class="activity-item">
                    <div class="activity-avatar bg-primary">
                        AK
                    </div>

                    <div class="flex-grow-1">
                        <h6>Arjun Kumar</h6>
                        <p>Submitted Mathematics Assignment</p>
                    </div>

                    <small class="badge text-bg-secondary">12,590/-</small>
                </div>

                <div class="activity-item">
                    <div class="activity-avatar bg-success">
                        RS
                    </div>

                    <div class="flex-grow-1">
                        <h6>Riya Sharma</h6>
                        <p>Attendance marked present</p>
                    </div>

                    <small class="badge text-bg-secondary">18,680/-</small>
                </div>

                <div class="activity-item">
                    <div class="activity-avatar bg-warning text-dark">
                        VK
                    </div>

                    <div class="flex-grow-1">
                        <h6>Vikas Kumar</h6>
                        <p>Requested assignment extension</p>
                    </div>

                    <small class="badge text-bg-secondary">11,240/-</small>
                </div>

                <div class="activity-item">
                    <div class="activity-avatar bg-danger">
                        AM
                    </div>

                    <div class="flex-grow-1">
                        <h6>Anjali Mehta</h6>
                        <p>Scored 98% in Physics Test</p>
                    </div>

                    <small class="badge text-bg-secondary">15,500/-</small>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row g-3 mt-1">
    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <div>
                    <h5>Quick Actions</h5>
                    <small class="text-muted">
                        Main Menu Items to Manage all your data.
                    </small>
                </div>
            </div>
            <div class="quick-actions">
                <a href="#" class="quick-action-box">
                    <i class="bi bi-person-check"></i>
                    <span>Take Attendance</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-upload"></i>
                    <span>Upload Notes</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-file-earmark-plus"></i>
                    <span>Create Exam</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-journal-text"></i>
                    <span>Add Homework</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-chat-square-dots"></i>
                    <span>Parent Chat</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-cloud-arrow-up"></i>
                    <span>Upload Marks</span>
                </a>

            </div>
        </div>
    </div>
    <!-- Timetable -->
    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <div>
                    <h5>Today's Schedule</h5>
                    <small class="text-muted">
                        Manage all your schedules
                    </small>
                </div>
                <button class="btn btn-sm btn-light">
                    View All
                </button>
            </div>

            <div class="schedule-list">
                <div class="schedule-item active-class">
                    <div class="schedule-time">
                        09:00
                    </div>

                    <div class="schedule-content">
                        <h6>Mathematics</h6>
                        <p>Class 10-A | Room 204</p>
                    </div>

                    <small class="badge bg-success p-2 rounded-circle">
                        <span class="visually-hidden">&nbsp;</span>
                    </small>
                </div>

                <div class="schedule-item">
                    <div class="schedule-time">
                        11:00
                    </div>

                    <div class="schedule-content">
                        <h6>Physics</h6>
                        <p>Class 11-B | Room 106</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-time">
                        01:30
                    </div>

                    <div class="schedule-content">
                        <h6>Chemistry</h6>
                        <p>Class 12-A | Lab 2</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-time">
                        01:30
                    </div>

                    <div class="schedule-content">
                        <h6>Chemistry</h6>
                        <p>Class 12-A | Lab 2</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-time">
                        01:30
                    </div>

                    <div class="schedule-content">
                        <h6>Chemistry</h6>
                        <p>Class 12-A | Lab 2</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <app-todo [stats]="true" [title]="true"></app-todo>
        </div>
    </div>
</div>